import React from "react";

const InfoContactUs = () => {
  return (
    <div>
      <div class="large-12 columns">
        <div class="large-12 columns">
          <div class="panel">
            <h3>Customer Care</h3>
            <p>Call Us: 0861 444 822</p>
            <p>E-mail: <a href="mailto:Customercare@4racing.com">Customercare@4racing.com</a></p>
          </div>
        </div>

        <div class="large-12 columns">
          <div class="panel">
            <h3>Info Lines</h3>
            <p>For fixtures, results, and dividends.</p>
            <ul class="no-bullet">
              <li>Johannesburg 011 210 1100</li>
              <li>Pretoria 012 423 1100</li>
              <li>Western Cape 021 764 1100</li>
              <li>Bloemfontein 051 410 1100</li>
              <li>Port Elizabeth 041 390 1100</li>
              <li>East London 043 703 1100</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoContactUs;
